<script setup>
import PrimaryButton from "@/Components/PrimaryButton.vue";
import SecondaryButton from "@/Components/SecondaryButton.vue";
import PublicLayout from "@/Layouts/PublicLayout.vue";
import DlgCasoBuscar from "@/Pages/Publico/DlgCasoBuscar.vue";
import {ref} from "vue";
import FootFC from "@/Components/FootFC.vue";


const dlgBuscar = ref(null);

const buscar = () => {
    dlgBuscar.value.open({}
        , (res) => {
            Object.keys(res.piezas).forEach(key => piezas[key] = res.piezas[key]);
        });

}


</script>

<template>
    <PublicLayout title="Nuestro Compromiso">

        <DlgCasoBuscar ref="dlgBuscar"/>

        <div class="py-2 sm:py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg font-body text-md">
                    <div class="mx-4 sm:mx-6 lg:mx-14 my-6 sm:my-12">
                        <h1 class="font-head font-bold text-xl uppercase leading-tight text-red-900 mb-6">
                            Nuestro compromiso
                        </h1>

                        <p class="mb-4">
                        En la Fundación Carolina actuamos con integridad, ética y responsabilidad en todas
                        nuestras actividades, tanto internas como externas. Nuestra misión es promover la
                        cooperación educativa y cultural entre España y los países de Iberoamérica, siempre con
                        un enfoque de excelencia, equidad y respeto por los derechos humanos. A lo largo de
                        nuestra trayectoria, hemos trabajado para contribuir al progreso social, educativo y
                        científico, manteniendo siempre un firme compromiso con los valores que guían nuestra
                        labor.
                        </p>
                        <p class="mb-4">
                        Creemos en la importancia de la transparencia y la honestidad en todas nuestras
                        relaciones, y por ello hemos implementado el Canal de Denuncias como una herramienta
                        esencial para garantizar que cualquier infracción o irregularidad sea identificada y
                        corregida de forma eficaz. Este canal está disponible para todas las personas que forman
                        parte de nuestra organización y se relacionan con ella.
                        </p>
                        <p class="mb-4">
                        La Fundación Carolina garantiza que todas las denuncias serán tratadas con el máximo
                        respeto, confidencialidad y profesionalismo. Nos comprometemos a garantizar que no
                        habrá represalias contra quienes utilicen este mecanismo, fomentando un entorno seguro
                        y de confianza para la comunicación de irregularidades o conductas inapropiadas. Cada
                        denuncia será investigada con seriedad, imparcialidad y diligencia, protegiendo siempre
                        la identidad de las personas involucradas, ya sea que se identifiquen o realicen la denuncia
                        de forma anónima. Este compromiso refuerza nuestra responsabilidad de actuar conforme
                        a los más altos estándares éticos y legales, alineados con los principios y valores que
                        guían nuestra misión.
                        </p>
                    </div>

                    <div class="m-10 flex flex-row flex-wrap">
                        <div class="md:basis-1/2 md:text-right md:pr-6 basis-full text-center mb-4">
                            <primary-button class="h-12 w-60" onclick="window.location='/caso';">
                                Crear nueva comunicación
                            </primary-button>
                        </div>
                        <div class="md:basis-1/2 md:text-left md:pl-6 basis-full text-center mb-4">
                            <secondary-button class="h-12 w-60" @click="buscar();">
                                Seguimiento de comunicación existente
                            </secondary-button>
                        </div>
                    </div>

                    <FootFC class="mx-10 my-6"/>

                </div>
            </div>
        </div>
    </PublicLayout>
</template>
